import PlaceholderImage from '../../../atoms/placeholderImage/PlaceholderImage';
import ProductImage from '../../cartPage/cartItem/components/ProductImage';
import ProductName from '../../cartPage/cartItem/components/ProductName';
import ProductOption from '../../cartPage/cartItem/components/ProductOption';
import ProductPrice from '../../cartPage/cartItem/components/ProductPrice';
import RemoveButton from '../../cartPage/cartItem/components/RemoveButton';
import styles from './GiftCartItem.module.scss';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from '../../../atoms/link/Link';
import clsx from 'clsx';

const MiniCartItem = ({
  item = {},
  removeFromCart = () => {},
  setShowDialog = () => {},
  onCheckout = false,
  hideRemoveIcon = false,
}) => {
  const {
    projectSpecificData: { original },
  } = item;
  const noMessage = !item.variant.attributes.message;

  return (
    <div
      className={clsx(
        styles.cartItem,
        onCheckout ? styles.cartItemCheckout : '',
      )}
    >
      <div className={styles.product} id={item.lineItemId}>
        <Link
          className={styles.productImageBlock}
          link={original._url}
          onClick={() => setShowDialog(false)}
        >
          {item.variant && item.variant.images[0] ? (
            <ProductImage
              customClasses={{
                productImage: styles.productImage,
              }}
              alt={item.name}
              image={item.variant && item.variant.images[0]}
            />
          ) : (
            <div className={styles.productImage}>
              <PlaceholderImage />
            </div>
          )}
        </Link>
        <div className={styles.productContent}>
          <div className={styles.productNameAndRemove}>
            {item.name && (
              <Link link={original._url} onClick={() => setShowDialog(false)}>
                <ProductName className={styles.productName} name={item.name} />
              </Link>
            )}
            {!hideRemoveIcon && (
              <RemoveButton
                placement="minicart"
                removeFromCart={(uniqId) => removeFromCart(uniqId, item)}
                uniqueId={item.lineItemId}
                fill="#949494"
              />
            )}
          </div>
          <div className={styles.productOptions}>
            {item.variant &&
              item.variant.attributes &&
              item.variant.attributes.receiverName && (
                <ProductOption
                  label="Recipient Name"
                  labelClassName={styles.optionLabel}
                  color={item.variant.attributes.receiverName}
                  className={`${styles.optionName} ${styles.optionCommon}`}
                />
              )}
            <div
              className={clsx({
                [styles.footer]: noMessage,
                [styles.alignItemsCenter]: noMessage,
              })}
            >
              {item.variant &&
                item.variant.attributes &&
                item.variant.attributes.email && (
                  <ProductOption
                    label="Recipient Email"
                    labelClassName={styles.optionLabel}
                    color={item.variant.attributes.email}
                    className={`${styles.optionEmail} ${styles.optionCommon}`}
                  />
                )}
              {noMessage && (
                <div className={styles.wishlistAndSubtotal}>
                  <ProductPrice
                    placement="minicart"
                    fullPrice={item.price}
                    discountPrice={item.discountedPrice}
                    className={styles.priceOption}
                  />
                </div>
              )}
            </div>
          </div>
          <div className={styles.footer}>
            {item.variant &&
              item.variant.attributes &&
              item.variant.attributes.message && (
                <ProductOption
                  label="Message"
                  labelClassName={styles.optionLabel}
                  color={item.variant.attributes.message}
                  className={`${styles.optionCommon} ${styles.optionMessage}`}
                />
              )}
            {!noMessage && (
              <div className={styles.wishlistAndSubtotal}>
                <ProductPrice
                  placement="minicart"
                  fullPrice={item.price}
                  discountPrice={item.discountedPrice}
                  className={styles.priceOption}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

MiniCartItem.propTypes = {
  item: PropTypes.object,
  removeFromCart: PropTypes.func,
  setShowDialog: PropTypes.func,
};

export default MiniCartItem;
